import React from 'react';
import CapacityPlantTemplate from '../../components/CapacityPlantTemplate';
import { capacityPlants } from '../../data/capacityPlants';

const WaterPlant40BPM = () => (
  <CapacityPlantTemplate plant={capacityPlants['/40-bpm-water-plant']} path="/40-bpm-water-plant" />
);

export default WaterPlant40BPM;
